import { atom } from "recoil";
import { Band } from "../../Pages/Companies/TransportPrices/transportPriceBands";

export interface TransportPriceClipboard {
	sourceKey: string;
	typeKey: string;
	sourceLabel: string;
	isOwn: boolean;
	bands: Band[];
}

const transportPriceClipboardAtom = atom<TransportPriceClipboard | null>({
	key: "transportPriceClipboard",
	default: null
});

export { transportPriceClipboardAtom };
